import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoExtratoDadosCapaTnqPostos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoextratodadoscapatnqpostos/FIND_EXTRADADOSCAPATNQPOSTOS':
      case '@operacaoextratodadoscapatnqpostos/UPDATE_EXTRADADOSCAPATNQPOSTOS':
      case '@operacaoextratodadoscapatnqpostos/DELETE_EXTRADADOSCAPATNQPOSTOS':
      case '@operacaoextratodadoscapatnqpostos/STORE_EXTRADADOSCAPATNQPOSTOS':
      case '@operacaoextratodadoscapatnqpostos/EXTRADADOSCAPATNQPOSTOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoextratodadoscapatnqpostos/SUCCESS_REMOVE':
      case '@operacaoextratodadoscapatnqpostos/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoextratodadoscapatnqpostos/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoextratodadoscapatnqpostos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoextratodadoscapatnqpostos/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoextratodadoscapatnqpostos;
        break;
      }

      case '@operacaoextratodadoscapatnqpostos/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
